"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "M20.2359 10.3544H19.56V10.32H12v3.36h4.7479c-.6939 1.9556-2.5544 3.36-4.7479 3.36-2.7842 0-5.04-2.2559-5.04-5.04 0-2.7842 2.2558-5.04 5.04-5.04 1.2846 0 2.4543.484 3.3436 1.2764l2.3756-2.3756C16.2197 4.4629 14.2132 3.6 12 3.6c-4.6397 0-8.4 3.7603-8.4 8.4s3.7603 8.4 8.4 8.4 8.4-3.7603 8.4-8.4a8.375 8.375 0 0 0-.1641-1.6456Z", clipRule: "evenodd" })), 'GoogleIcon');
